export const TAX_INVOICE_TEMPLATE = [
  { consumerId: 0, label: "Transport Invoice - Left Align", value: "TransportInvoice" },
  { consumerId: 0, label: "Transport Invoice - Right Align", value: "TransportInvoice_2" },
  { consumerId: 0, label: "Transport Invoice - Center Align", value: "TransportInvoice_3" },
  { consumerId: 0, label: "Transport Invoice - Split Layout", value: "TransportInvoice_4" },
  { consumerId: 0, label: "Transport Invoice - Advance", value: "TransportInvoice_5" },
  { consumerId: 0, label: "Transport Invoice - Body Only", value: "TransportInvoice_BodyOnly" },
  { consumerId: 0, label: "Transportation Details Report", value: "TransportInvoice_2Page" },
  { consumerId: 32, label: "Dimension", value: "PrintInvoiceLWH" },
  { consumerId: 21, label: "Dimension", value: "PrintInvoiceLWH" },
  { consumerId: 32, label: "Normal", value: "PrintInvoiceLWH_2" },
  { consumerId: 25, label: "Normal (A5)", value: "PrintInvoiceA5" },
  { consumerId: 0, label: "Normal (A4)", value: "PrintInvoice" },
  { consumerId: 0, label: "New Normal (A4) - Left Logo", value: "TaxInvoiceA4" },
  { consumerId: 0, label: "New Normal (A4) - Right Logo", value: "TaxInvoiceA4WithRightSideLogo" },
  {
    consumerId: 0,
    label: "Consiner & Consinee (A4)",
    value: "PrintInvoiceCourier",
  },
  {
    consumerId: 26,
    label: "Consiner & Consinee (A5)",
    value: "PrintInvoiceCourierA5",
  },
  {
    consumerId: 5,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 5,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 41,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 58,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },

  {
    consumerId: 1,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 1,
    label: "Consiner & Consinee (A5)",
    value: "PrintInvoiceCourierA5",
  },
  {
    consumerId: 41,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 1,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 68,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 68,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 68,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  { consumerId: 68, label: "Normal (A5)", value: "PrintInvoiceA5" },
  {
    consumerId: 76,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 76,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 76,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 14,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 14,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 14,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 80,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 80,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 80,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 125,
    label: "With Inline GST (A4)",
    value: "PrintInvoice-W-InlineGst",
  },
  {
    consumerId: 150,
    label: "Normal Format 2 (A4)",
    value: "PrintInvoiceFormat2",
  },
  {
    consumerId: 160,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 160,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 160,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 171,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 171,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 172,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 172,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 172,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 179,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 179,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 179,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 0,
    label: "Multiple Copy",
    value: "PrintInvoiceMain",
  },
  {
    consumerId: 180,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 180,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 180,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 146,
    label: "Print Challan",
    value: "ChallanPrintReportForSale",
  },
  {
    consumerId: 186,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 186,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 188,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 188,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 188,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 194,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 194,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 194,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 195,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 195,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 195,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 195,
    label: "Simple Pharma Retail (A4)",
    value: "SimplePrintInvoiceLandScape",
  },
  {
    consumerId: 196,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 196,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 196,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 197,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 197,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 197,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 198,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 198,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 198,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 199,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 199,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 199,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 200,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 200,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 200,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 201,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 201,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 201,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 202,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 202,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 202,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 203,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 203,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 203,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
  {
    consumerId: 205,
    label: "Pharma Wholsale (A5)",
    value: "PrintInvoicePharmaWholesale",
  },
  {
    consumerId: 205,
    label: "Pharma Wholsale (A4)",
    value: "PrintInvoicePharmaWholesaleA4",
  },
  {
    consumerId: 205,
    label: "Pharma Retail (A4)",
    value: "PrintInvoiceLandScape",
  },
];

export const QUOTATION_TEMPLATE = [
  { consumerId: 0, label: "Normal Format 2 (A4)", value: "PrintQuotationA4" },
  { consumerId: 0, label: "Normal (A4)", value: "PrintQuotationInvoice" },
];

export const LR_TEMPLATE = [
  { consumerId: 114, label: "Draft Copy", value: "LRPrintReportMain" },
  { consumerId: 114, label: "Normal Print", value: "LRDetailPrintReport" },
  { consumerId: 146, label: "Print (A4)", value: "ChallanPrintReportSec" },
  { consumerId: 114, label: "Special Formate", value: "LRPrintReportMainReverseFormate" },
];

export const VOUCHER_TEMPLATE = [
  { consumerId: 0, label: "Cash Payment", value: "CashPaymentVoucherReport" },
  { consumerId: 0, label: "Journal Voucher", value: "JournalVoucherReport" },
];

export const EWAY_BILL_ACCESS_CONSUMERS = [1, 14, 5, 3, 60, 4, 146];

export const PAGIINATION_OPTION = [
  { value: "5", label: "5" },
  { value: "10", label: "10" },
  { value: "15", label: "15" },
  { value: "20", label: "20" },
];

export const REPOR_FONTSIZE_OPTION = [
  { value: "8", label: "8px" },
  { value: "7", label: "7px" },
  { value: "6", label: "6px" },
  { value: "5", label: "5px" },
  { value: "4", label: "4px" },
];

export const SUMMARY_BY_DATETIME = [
  { value: "Monthly", label: "Monthly Summary" },
  { value: "Quarterly", label: "Quarterly Summary" },
  { value: "HalfYearly", label: "Half-Yearly Summary" },
  { value: "Detail", label: "Detail Summary" },
];

export const barcodeTypes = [
  { value: "UPCA", label: "UpcA" }, //only digits with length 11 or 12
  { value: "UPCE", label: "UpcE" }, // length 8 or 12 only and binary only
  { value: "UPCSUPPLEMENTAL2DIGIT", label: "UpcSupplemental2Digit" }, // lenth 2 with number only
  { value: "UPCSUPPLEMENTAL5DIGIT", label: "UpcSupplemental5Digit" }, // lenth 5 with number only
  { value: "EAN13", label: "Ean13" }, // numer only and length 12
  { value: "EAN8", label: "Ean8v" }, // length 8 and number only
  { value: "INTERLEAVED2OF5", label: "Interleaved2Of5" }, // length 6 and number only
  { value: "INTERLEAVED2OF5MOD10", label: "Interleaved2Of5Mod10" }, // length 7 and number only
  { value: "STANDARD2OF5", label: "Standard2Of5" }, // numbers only and max length is 20
  { value: "STANDARD2OF5MOD10", label: "Standard2Of5Mod10" }, //numbers only and max length 19
  { value: "INDUSTRIAL2OF5", label: "Industrial2Of5" }, //numbers only and max length 20
  { value: "INDUSTRIAL2OF5MOD10", label: "Industrial2Of5Mod10" }, //numbers only and max length 20
  { value: "CODE39", label: "Code39" }, //CAPITAL LATERS, number and special charters only(space$ ,% ,+ ,- ,. ,/,*) and max length 20
  { value: "CODE39EXTENDED", label: "Code39Extended" }, //CAPITAL LATERS, number and special charters only(space$ ,% ,+ ,- ,. ,/,*) and max length 22
  { value: "CODE39MOD43", label: "Code39Mod43" }, //CAPITAL LATERS, number and special charters only(space$ ,% ,+ ,- ,. ,/,*) and max length 22
  { value: "CODABAR", label: "Codabar" }, //CAPITAL LATERS, number and special charters only(space$ ,% ,+ ,- ,. ,/,*) and max length 22
  { value: "POSTNET", label: "PostNet" }, // should be 5, 6, 9, 11 digits
  { value: "BOOKLAND", label: "Bookland" },
  { value: "ISBN", label: "Isbn" },
  { value: "JAN13", label: "Jan13" },
  { value: "MSIMOD10", label: "MsiMod10" },
  { value: "MSI2MOD10", label: "Msi2Mod10" },
  { value: "MSIMOD11", label: "MsiMod11" },
  { value: "MSIMOD11MOD10", label: "MsiMod11Mod10" },
  { value: "MODIFIEDPLESSEY", label: "ModifiedPlessey" },
  { value: "CODE1,", label: "Code11" },
  { value: "USD8", label: "Usd8" },
  { value: "UCC12", label: "Ucc12" },
  { value: "UCC13", label: "Ucc13" },
  { value: "LOGMARS", label: "Logmars" },
  { value: "CODE128", label: "Code128" },
  { value: "CODE128A", label: "Code128A" },
  { value: "CODE128B", label: "Code128B" },
  { value: "CODE128C", label: "Code128C" },
  { value: "ITF14", label: "Itf14" },
  { value: "CODE93", label: "Code93" },
  { value: "TELEPEN", label: "Telepen" },
  { value: "FIM", label: "Fim" },
  { value: "PHARMACODE", label: "Pharmacode" },
];

export const ProductDrugTypes = [
  { value: "FOOD_PRODUCT", label: "Food Product" },
  { value: "GENERAL_PRODUCT", label: "General Product" },
  { value: "HOMEOPALTHY_PRODUCT", label: "Homeopalthy Product" },
  { value: "NON_SCHEDULE_DRUG", label: "Non-Schedule Drug" },
  { value: "SCHEDULE_DRUG", label: "Schedule Drug" },
  { value: "SCHEDULE_H1_DRUG", label: "Schedule H1 Drug" },
  { value: "SCHEDULE_X_DRUG", label: "Schedule - X Drug" },
  { value: "SCHEDULE_G", label: "Schedule G" },
  { value: "SCHEDULE_H", label: "Schedule H" },
];

export const barcodeTypeOptions = [
  { value: "barcode", label: "Barcode" },
  { value: "qrcode", label: "Qrcode" },
];

export const saleReceiptTypes = [
  { value: "APPEND_TO_INVOICE", label: "Against Invoice" },
  { value: "ADVANCE", label: "Advance" },
];

export const paymentTypes = [
  { value: "APPEND_TO_PURCHASE", label: "Against purchase" },
  { value: "ADVANCE", label: "Advance" },
];

export const TDS_PERCENTAGES = {
  WITH_PAN_NUMBER: 0.1,
  WITHOUT_PAN_NUMBER: 0.2,
};

export const TDS_PERCENTAGES_MESSEGES_SALE_RECEIPT = {
  WITH_PAN_NUMBER: "10% TDS applicable, as buyer's PAN Number available.",
  WITHOUT_PAN_NUMBER:
    "20% TDS applicable, as buyer's PAN Number not available.",
};

export const TDS_PERCENTAGES_MESSEGES_PAYMENT = {
  WITH_PAN_NUMBER: "10% TDS applicable, as you have PAN Number available.",
  WITHOUT_PAN_NUMBER:
    "20% TDS applicable, as you don't have PAN Number available.",
};

export const paymentModeTypes = [
  { label: "Cash", value: "CASH" },
  { label: "Credit", value: "CREDIT" },
  { label: "UPI/Online", value: "UPI/ONLINE" },
  { label: "Cheque", value: "CHEQUE" },
];

export const staffStatusOptions = [
  {
    value: "ACTIVE",
    label: "Active",
  },
  {
    value: "INACTIVE",
    label: "Inactive",
  },
];


export const DEBIT_NOTE_PRODUCT_TYPES = [
  { label: "Regular", value: "REGULAR" },
  { label: "Free", value: "FREE" },
  { label: "Immovable", value: "IMMOVABLE" },
  { label: "Damaged", value: "DAMAGED" },
  { label: "Replace", value: "REPLACE" },
  { label: "Rate Difference", value: "RATE_DIFFERENCE" },
];

export const DEBIT_NOTE_REASONS = [
  { label: "01 - Sales Return", value: "01_SALES_RETURN" },
  { label: "02 - Post Sale Discount", value: "02_POST_SALE_DISCOUNT" },
  { label: "03 - Deficiency in Service", value: "03_DEFICIENCY_IN_SERVICE" },
  { label: "04 - Correction in Invoice", value: "04_CORRECTION_IN_INVOICE" },
  { label: "05 - Change in POS", value: "05_CHANGE_IN_POS" },
  { label: "06 - Finalization of Provisional Assessment", value: "06_FINALIZATION_OF_PROVISIONAL_ASSESSMENT" },
  { label: "07 - Others", value: "07_OTHERS" }
];